import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum ClearanceRouteNames {
  CLEARANCE_TABLE = "CLEARANCE_TABLE",
  CLEARANCE_DETAIL = "CLEARANCE_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Clearance = { clearanceId: string };
type Query = { query?: Record<string, string> };

export class ClearanceGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = ClearanceGoToHelper.locations;

    return {
      ClearanceTable: (partnerId: string) => {
        return {
          text: $t("clearance.clearances").toString(),
          exact: true,
          to: locations.clearanceTable({ partnerId })
        };
      },
      ClearanceDetail: (partnerId: string, clearanceId: string) => {
        return {
          text: $t("common.nouns.detail").toString(),
          exact: true,
          to: locations.clearanceDetail({ partnerId, clearanceId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    clearanceTable: (d: Partner & Query) => {
      return {
        name: ClearanceRouteNames.CLEARANCE_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    clearanceDetail: (d: Partner & Clearance & Query) => {
      return {
        name: ClearanceRouteNames.CLEARANCE_DETAIL,
        params: { partnerId: d.partnerId, clearanceId: d.clearanceId },
        query: d.query
      };
    }
  };

  goToClearanceTable(d: Tab & Partner & Query) {
    this.go(ClearanceGoToHelper.locations.clearanceTable(d), d.newTab);
  }

  goToClearanceDetail(d: Tab & Partner & Clearance & Query) {
    this.go(ClearanceGoToHelper.locations.clearanceDetail(d), d.newTab);
  }
}
